import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export const trackScheduledConflictsEvent = createTrackerForCategory('ScheduledConflicts');
